import { forwardRef } from 'react';

import { cn } from '@/shared/utils/cn/cn.util';

import { fieldBlockVariants } from '../field/field.tokens';

import { type TextareaProps } from './Textarea.types';

/** The default row count. Four lines fit a description without dominating a form. */
const DEFAULT_ROWS = 4;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, isInvalid = false, rows, textareaSize, ...props },
  ref,
) {
  return (
    <textarea
      ref={ref}
      rows={rows ?? DEFAULT_ROWS}
      aria-invalid={isInvalid ? true : undefined}
      // The HEIGHT-LESS block surface: `rows` is the height, and nothing here
      // overrides it. `resize-y` is a default, not a law — a control that grows
      // with its content (the JSON editor) passes `resize-none` and drives the
      // row count itself.
      className={cn(fieldBlockVariants({ fieldSize: textareaSize }), 'resize-y', className)}
      {...props}
    />
  );
});
